import React, { useEffect, useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography';
import { Line } from 'react-chartjs-2';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles({
    root: {
        minWidth: 275,
    },

    card: {
        flexGrow: 1,
        backgroundColor: "#ffffff",
        paddingInlineStart: '10px',
        borderRadius: '10px',
        boxShadow: ' 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
        widht: 'auto',
        height: 'auto',
        marginTop: 30
    },

    title: {
        fontSize: 15,
        color: "#229954"
    },
    titleMin: {
        fontSize: 30,
        alignContent: 'center'
    },
    titleSecondary: {
        fontSize: 15,
        alignContent: 'center'
    },
    titleBadge: {
        backgroundColor: '#229954',
        width: "25px",
        height: "25px",
        color: 'white',
        fontSize: '1.0rem'
    }

});

export const CommonBadgeGenerate = ({ cardTitle, badgeName }) => {
    const classes = useStyles();
    return (
        <Grid container>
            <Grid item md={11} xs={11} >
                {cardTitle}
            </Grid>
            <Grid item md={1} xs={1}>
                <div>
                    <Avatar
                        size="small"
                        className={classes.titleBadge}
                    >
                        {badgeName}
                    </Avatar>
                </div>
            </Grid>
        </Grid>
    )
}